/* eslint-disable no-shadow */

export enum IncodeSessionStatus {
	created = 'created',
	completed = 'completed',
	failed = 'failed',
}

export enum IncodeStatusEnum {
	ok = 'OK',
	warn = 'WARN',
	fail = 'FAIL',
}

export const STATUS_LABEL: Record<IncodeSessionStatus, string> = {
	[IncodeSessionStatus.created]: 'En proceso',
	[IncodeSessionStatus.completed]: 'Completado',
	[IncodeSessionStatus.failed]: 'Fallido',
};

export const STATUS_COLOR: Record<IncodeSessionStatus, string> = {
	[IncodeSessionStatus.created]: 'yellow_100',
	[IncodeSessionStatus.completed]: 'green_300',
	[IncodeSessionStatus.failed]: 'red_300',
};

export const RESULT_STATUS_LABEL: Record<IncodeStatusEnum, string> = {
	[IncodeStatusEnum.ok]: 'OK',
	[IncodeStatusEnum.warn]: 'OK con advertencias',
	[IncodeStatusEnum.fail]: 'Falló',
};

export const RESULT_STATUS_COLOR: Record<IncodeStatusEnum, string> = {
	[IncodeStatusEnum.ok]: 'green_300',
	[IncodeStatusEnum.warn]: 'yellow_100',
	[IncodeStatusEnum.fail]: 'red_300',
};
